import { c as _c } from "react/compiler-runtime";
import { FormSelect, Modal, ModalSizeEnum, PrimaryButton } from '@systemeio/ui';
import { CampaignId } from 'modules/campaigns/types/campaign-interface';
import { useContactsImportColumnsSelectOptions } from 'modules/contacts/contacts-import/hook/use-contacts-import-columns-select-options';
import { useGetPreviewOfImportContactsTable } from 'modules/contacts/contacts-import/hook/use-get-preview-of-import-contacts-table';
import { useSendImportContacts } from 'modules/contacts/contacts-import/hook/use-send-import-contacts';
import { ContactsImportColumnsSelectedColumnsFrontend } from 'modules/contacts/contacts-import/types/contacts-import-column-select';
import { ContactsImportDelimiter } from 'modules/contacts/contacts-import/types/contacts-import-delimeter-type';
import { ContactsImportFileColumnName, ContactsImportFileDataFrontendType } from 'modules/contacts/contacts-import/types/contacts-import-file-interface';
import { ContactBulkApiInterface } from 'modules/contacts/types/contact-menu-interface';
import React, { useEffect, useMemo, useState } from 'react';
import { ColumnWithExtraHeaderInterface, TableWithExtraHeaders } from 'shared/components/table/table-with-extra-headers';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { DataWithPaginationInterface } from 'shared/types/pagination-interface';
import { ArrowRightIcon } from '@systemeio/ui/icons';
export interface SelectColumnsForContactsImportModalProps {
  file: File | null;
  delimiter: ContactsImportDelimiter;
  campaign: CampaignId | undefined;
  tags: Array<ContactBulkApiInterface> | undefined;
  onConfirm: () => Promise<void>;
  clearStates: () => void;
}
export const SelectColumnsForContactsImportModal = t0 => {
  const $ = _c(68);
  const {
    file,
    delimiter,
    campaign,
    tags,
    onConfirm,
    clearStates
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isOpened, setIsOpened] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [selectedColumns, setSelectedColumns] = useState(t1);
  const [fileData, setFileData] = useState(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [fileHeaders, setFileHeaders] = useState(t2);
  const [fileHasHeaders, setFileHasHeaders] = useState();
  const {
    contactsImportColumnsSelectOptions
  } = useContactsImportColumnsSelectOptions();
  const {
    fetcherGetPreviewOfImportContactsTable,
    isGetPreviewOfImportContactsTableFetching
  } = useGetPreviewOfImportContactsTable();
  const {
    fetcherSendImportContacts,
    isSendImportContactsFetching,
    sendImportContactsError,
    resetSendImportContactsError
  } = useSendImportContacts();
  let t3;
  if ($[2] !== resetSendImportContactsError) {
    t3 = () => {
      setIsOpened(false);
      resetSendImportContactsError();
    };
    $[2] = resetSendImportContactsError;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onClose = t3;
  let t4;
  if ($[4] !== contactsImportColumnsSelectOptions || $[5] !== fileHeaders || $[6] !== selectedColumns || $[7] !== sendImportContactsError?.columns) {
    let t5;
    if ($[9] !== contactsImportColumnsSelectOptions || $[10] !== selectedColumns || $[11] !== sendImportContactsError?.columns) {
      t5 = (columnName, index) => ({
        key: columnName,
        header: columnName,
        widthPercent: 25,
        extraHeader: <FormSelect data={contactsImportColumnsSelectOptions} onChange={value => {
          setSelectedColumns(prev => ({
            ...prev,
            [index]: value ?? null
          }));
        }} value={selectedColumns[index]} error={sendImportContactsError?.columns[index]} isPreFetching={!contactsImportColumnsSelectOptions} />
      });
      $[9] = contactsImportColumnsSelectOptions;
      $[10] = selectedColumns;
      $[11] = sendImportContactsError?.columns;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = fileHeaders.map(t5);
    $[4] = contactsImportColumnsSelectOptions;
    $[5] = fileHeaders;
    $[6] = selectedColumns;
    $[7] = sendImportContactsError?.columns;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const columns = t4;
  let t5;
  if ($[13] !== delimiter || $[14] !== fetcherGetPreviewOfImportContactsTable || $[15] !== file) {
    t5 = async () => {
      ;
      try {
        const {
          headers,
          dataForFrontend,
          fileHasHeaders: fileHasHeaders_0
        } = await fetcherGetPreviewOfImportContactsTable({
          file: file as File,
          delimiter
        });
        setFileHeaders(headers);
        setFileData(dataForFrontend);
        setFileHasHeaders(fileHasHeaders_0);
        setIsOpened(true);
      } catch (t6) {
        const e = t6;
      }
    };
    $[13] = delimiter;
    $[14] = fetcherGetPreviewOfImportContactsTable;
    $[15] = file;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const onChooseData = t5;
  let t6;
  if ($[17] !== campaign || $[18] !== clearStates || $[19] !== delimiter || $[20] !== fetcherSendImportContacts || $[21] !== file || $[22] !== onConfirm || $[23] !== selectedColumns || $[24] !== tags) {
    t6 = async () => {
      ;
      try {
        await fetcherSendImportContacts({
          file,
          delimiter,
          campaign,
          tags,
          selectedColumnsFrontend: selectedColumns
        });
        setIsOpened(false);
        await onConfirm();
        clearStates();
      } catch (t7) {
        const e_0 = t7;
      }
    };
    $[17] = campaign;
    $[18] = clearStates;
    $[19] = delimiter;
    $[20] = fetcherSendImportContacts;
    $[21] = file;
    $[22] = onConfirm;
    $[23] = selectedColumns;
    $[24] = tags;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  const handleConfirm = t6;
  let t7;
  let t8;
  if ($[26] !== contactsImportColumnsSelectOptions || $[27] !== fileData || $[28] !== fileHeaders) {
    t7 = () => {
      if (fileData && contactsImportColumnsSelectOptions) {
        contactsImportColumnsSelectOptions?.forEach(option => fileHeaders.some((headerValue, headerIndex) => {
          if (option.caption.toLowerCase() === headerValue.toLocaleLowerCase()) {
            setSelectedColumns(prev_0 => ({
              ...prev_0,
              [headerIndex]: option.id
            }));
            return true;
          } else {
            return false;
          }
        }));
      }
    };
    t8 = [contactsImportColumnsSelectOptions, fileData, fileHeaders];
    $[26] = contactsImportColumnsSelectOptions;
    $[27] = fileData;
    $[28] = fileHeaders;
    $[29] = t7;
    $[30] = t8;
  } else {
    t7 = $[29];
    t8 = $[30];
  }
  useEffect(t7, t8);
  const t9 = !file;
  let t10;
  if ($[31] !== t) {
    t10 = t("global.next");
    $[31] = t;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ArrowRightIcon />;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== isGetPreviewOfImportContactsTableFetching || $[35] !== onChooseData || $[36] !== t10 || $[37] !== t9) {
    t12 = <PrimaryButton disabled={t9} isFetching={isGetPreviewOfImportContactsTableFetching} onClick={onChooseData}>{t10}{t11}</PrimaryButton>;
    $[34] = isGetPreviewOfImportContactsTableFetching;
    $[35] = onChooseData;
    $[36] = t10;
    $[37] = t9;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== t) {
    t13 = t("dashboard.contact_import.select_columns_table.title");
    $[39] = t;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== sendImportContactsError) {
    t14 = sendImportContactsError?.common && <p className="text-danger text-center text-sm" dangerouslySetInnerHTML={{
      __html: sendImportContactsError.common
    }} />;
    $[41] = sendImportContactsError;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  const t15 = fileData || undefined;
  const t16 = !fileHasHeaders;
  let t17;
  if ($[43] !== columns || $[44] !== t15 || $[45] !== t16) {
    t17 = <TableWithExtraHeaders data={t15} columns={columns} noHeader={t16} />;
    $[43] = columns;
    $[44] = t15;
    $[45] = t16;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  const t18 = !contactsImportColumnsSelectOptions;
  let t19;
  if ($[47] !== handleConfirm) {
    t19 = e_1 => {
      e_1.preventDefault();
      handleConfirm();
    };
    $[47] = handleConfirm;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t) {
    t20 = t("dashboard.contact_import.import_table.import_button.label");
    $[49] = t;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== isSendImportContactsFetching || $[52] !== t18 || $[53] !== t19 || $[54] !== t20) {
    t21 = <div className="flex justify-center"><PrimaryButton isFetching={isSendImportContactsFetching} disabled={t18} onClick={t19}>{t20}</PrimaryButton></div>;
    $[51] = isSendImportContactsFetching;
    $[52] = t18;
    $[53] = t19;
    $[54] = t20;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  let t22;
  if ($[56] !== t14 || $[57] !== t17 || $[58] !== t21) {
    t22 = <form className="m-auto flex max-w-fit flex-col gap-6 overflow-hidden lg:gap-10">{t14}{t17}{t21}</form>;
    $[56] = t14;
    $[57] = t17;
    $[58] = t21;
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  let t23;
  if ($[60] !== isOpened || $[61] !== onClose || $[62] !== t13 || $[63] !== t22) {
    t23 = <Modal className="max-w-[100vw]" size={ModalSizeEnum.medium} isCentered={true} opened={isOpened} onClose={onClose} title={t13}>{t22}</Modal>;
    $[60] = isOpened;
    $[61] = onClose;
    $[62] = t13;
    $[63] = t22;
    $[64] = t23;
  } else {
    t23 = $[64];
  }
  let t24;
  if ($[65] !== t12 || $[66] !== t23) {
    t24 = <>{t12}{t23}</>;
    $[65] = t12;
    $[66] = t23;
    $[67] = t24;
  } else {
    t24 = $[67];
  }
  return t24;
};